// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".code,.code-game{position:relative}.code button,.code-game button{position:absolute;top:0;right:0}.copy-btn{position:absolute;top:0;right:0;height:40px !important;background:none !important}.copy-btn span.v-ripple_container{opacity:0 !important}.copy-btn:hover:before{opacity:0 !important}", ""]);
// Exports
module.exports = exports;
